import React, {
  useState,
  useRef,
  useLayoutEffect,
  RefObject,
  useEffect,
} from "react";
import Overlay from "../helpers/Overlay";
import setAxis from "../helpers/Views/Interactions";
import { Heartbeat } from "../helpers/heartbeat";
import { useNavigate } from "react-router";
import gsap from "gsap";

enum Interactions {
  VENA_AMPLIFY,
  VENI_CLL17,
  VENO_CLL17,
  VENO_CLL14,
}

const IMG_1 = "./assets/imgs/Intro3.png";

const VenBasedMenu = () => {
  // States
  const [redirectUser, setRedirectUser] = useState<Boolean | null>(false);
  const [remainingTime, setRemainingTime] = useState<Number | null>(null);
  const [progress, setProgress] = useState<Number | null>(null);
  const [askisngStillThere, setAskisngStillThere] = useState<Boolean | null>(
    null,
  );
  const [isOpenOverlay, setisOpenOverlay] = useState<boolean>(false);
  const [imagesOverlay, setImagesOverlay] = useState<Array<string> | undefined>(
    [],
  );

  let navigate = useNavigate();

  // Refs
  const menu_video = useRef(null);
  const VENA_AMPLIFY = useRef<HTMLDivElement>(null);
  const VENI_CLL17 = useRef<HTMLDivElement>(null);
  const VENO_CLL17 = useRef<HTMLDivElement>(null);
  const VENO_CLL14 = useRef<HTMLDivElement>(null);

  const handleOpenModal = (
    ref: RefObject<HTMLDivElement | null>,
    name: Interactions,
    imgs: Array<string>,
  ) => {
    setisOpenOverlay(!isOpenOverlay);
    setImagesOverlay(imgs);
  };

  useLayoutEffect(() => {
    setAxis({
      position: { x: { pos: 8, value: 600 }, y: { pos: 66, value: 200 } },
      element: VENA_AMPLIFY.current,
    });
    setAxis({
      position: { x: { pos: 31, value: 620 }, y: { pos: 66, value: 200 } },
      element: VENI_CLL17.current,
    });
    setAxis({
      position: { x: { pos: 50, value: 635 }, y: { pos: 66, value: 200 } },
      element: VENO_CLL17.current,
    });
    setAxis({
      position: { x: { pos: 76, value: 620 }, y: { pos: 66, value: 200 } },
      element: VENO_CLL14.current,
    });
  }, []);

  const handleTimeout = () => {
    setRedirectUser(true);
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  const handleTick = (remainingTime: any) => {
    if (remainingTime <= 10) {
      const progress = remainingTime * 10;
      setProgress(progress);
    }
    return setRemainingTime(remainingTime);
  };

  const myHeartbeat = useRef<Heartbeat | null>(null);
  useEffect(() => {
    const heartbeat: any = new Heartbeat(
      30 * 1000,
      handleTimeout,
      handleTick,
      setAskisngStillThere,
    );

    myHeartbeat.current = heartbeat;

    heartbeat.start();

    const handleActivity = () => heartbeat.reset();

    document.addEventListener("mousemove", handleActivity);
    document.addEventListener("click", handleActivity);
    document.addEventListener("keydown", handleActivity);

    return () => {
      heartbeat.stop();
      document.removeEventListener("mousemove", handleActivity);
      document.removeEventListener("click", handleActivity);
      document.removeEventListener("keydown", handleActivity);
    };
  }, []);

  useEffect(() => {
    gsap.fromTo(
      "#ven_base_menu_img",
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 1 },
    );
  }, []);

  return (
    <div id="ven_base_menu" className="h-screen">
      {askisngStillThere && (
        <div
          id="pop_up_still_there"
          className="absolute w-full h-full bg-slate-950 bg-opacity-90 z-50 flex justify-center items-center"
        >
          {!redirectUser && (
            <img
              className="w-[28vw]"
              src={`${
                process.env.PUBLIC_URL
              }/assets/imgs/stillthere.png?v=1.0.1`}
              alt="Still there?"
            />
          )}
        </div>
      )}

      <div className="w-full h-full bg-[#021220] fixed z-10 opacity-40"></div>
      <video
        autoPlay
        playsInline
        loop
        muted
        className={`h-full w-full object-cover pointer-events-none fixed`}
      >
        <source
          src={`${process.env.PUBLIC_URL}/assets/screensavers/2026.mp4`}
          ref={menu_video}
        />
      </video>
      <div
        id="ven_base_menu_img"
        className="absolute inset-0 flex items-center justify-center pointer-events-none z-10"
      >
        <img
          // ref={img1Ref}
          src={IMG_1}
          alt="Screen 1"
          className="absolute w-full h-full object-contain will-change-transform"
        />
      </div>

      {/* Interactions */}
      {/* VEN + A */}
      <div
        ref={VENA_AMPLIFY}
        onClick={() =>
          handleOpenModal(VENA_AMPLIFY, Interactions.VENA_AMPLIFY, [
            `${process.env.PUBLIC_URL}/assets/imgs/AMPLIFY.png?v=1.0.1`,
          ])
        }
        className={`fixed bg-transparent opacity-1 z-20`}
      ></div>
      {/* VEN + I */}
      <div
        ref={VENI_CLL17}
        onClick={() =>
          handleOpenModal(VENI_CLL17, Interactions.VENI_CLL17, [
            `${process.env.PUBLIC_URL}/assets/imgs/GLOW.png?v=1.0.1`,
          ])
        }
        className={`fixed bg-transparent opacity-1 z-20`}
      ></div>
      {/* VEN + O */}
      <div
        ref={VENO_CLL17}
        onClick={() =>
          handleOpenModal(VENO_CLL17, Interactions.VENO_CLL17, [
            `${process.env.PUBLIC_URL}/assets/imgs/CAPTIVATE.png?v=1.0.1`,
          ])
        }
        className={`fixed bg-transparent opacity-1 z-20`}
      ></div>
      <div
        ref={VENO_CLL14}
        onClick={() =>
          handleOpenModal(VENO_CLL14, Interactions.VENO_CLL14, [
            `${process.env.PUBLIC_URL}/assets/imgs/CLL14_01.png?v=1.0.1`,
            `${process.env.PUBLIC_URL}/assets/imgs/CLL14_02.png?v=1.0.1`,
            `${process.env.PUBLIC_URL}/assets/imgs/CLL14_03.png?v=1.0.1`,
          ])
        }
        className={`fixed bg-transparent opacity-1 z-20`}
      ></div>
      {/* Overlay */}
      <Overlay
        imgs={imagesOverlay}
        open={isOpenOverlay}
        setClose={setisOpenOverlay}
      />
    </div>
  );
};

export default VenBasedMenu;
